import { FC } from 'react';
import { motion } from 'framer-motion';
import { FiCalendar } from 'react-icons/fi';
import { TSCardChevronRight } from '@/components/shared/card/Card';

export interface TemplateListItem {
  id: string;
  name: string;
  targetType: string;
  shiftCount: number;
  color?: string;
}

interface Props {
  templates: TemplateListItem[];
  onSelectTemplate: (templateId: string) => void;
}

const TemplateCard: FC<{ template: TemplateListItem; onSelectTemplate: (templateId: string) => void }> = ({
  template,
  onSelectTemplate
}) => {
  return (
    <motion.div key={template.id} animate={{ opacity: 1 }} initial={{ opacity: 0 }} exit={{ opacity: 0 }}>
      <TSCardChevronRight
        onClick={() => onSelectTemplate(template.id)}
        title={template.name}
        description={`${template.shiftCount} Shift${template.shiftCount === 1 ? '' : 's'}`}
        icon={
          <div className="p-2 rounded-full" style={{ backgroundColor: template.color }}>
            <FiCalendar className="h-6 w-6" style={{ color: template.color ? 'white' : 'black' }} />
          </div>
        }
      />
    </motion.div>
  );
};

export const TemplateList: FC<Props> = ({ templates, onSelectTemplate }) => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
      {templates.map(template => (
        <TemplateCard key={template.id} template={template} onSelectTemplate={onSelectTemplate} />
      ))}
    </div>
  );
};
